const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

const pad = (value: number) => String(value).padStart(2, '0');

/** A date value of the API (ISO string or date) as local date for editors. */
export const toEditorDate = (value: unknown): Date | null => {
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'string' && value.length) {
    const dateOnly = DATE_ONLY.exec(value)
      ? value.split('-').map((part) => +part)
      : null;
    const date = dateOnly
      ? new Date(dateOnly[0], dateOnly[1] - 1, dateOnly[2])
      : new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }
  return null;
};

/**
 * The value of a date field for a chosen day: the time of day of the value it
 * started with is kept, and the value is written in the format of that value (a
 * plain date stays a plain date, anything else becomes an ISO string in UTC).
 * Without a date the value is null.
 */
export const toDateValue = (date: Date | null, original: unknown) => {
  if (!date) {
    return null;
  }
  const time = toEditorDate(original);
  const value = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    time ? time.getHours() : 0,
    time ? time.getMinutes() : 0,
    time ? time.getSeconds() : 0,
    time ? time.getMilliseconds() : 0
  );
  return typeof original === 'string' && DATE_ONLY.test(original)
    ? `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(
        value.getDate()
      )}`
    : value.toISOString();
};
